<app-loader [loader]="loader.count" *ngIf="loader.count > 0"></app-loader>

<app-header></app-header>

<div class="container user-profile">
  <h2 class="user-profile__title">{{ 'PROFILE.MENU_PROFILE' | translate }}</h2>
  <div class="profile-container">
    <div class="profile-container__left">
      <div class="form-group">
        <label for="username">{{ 'PROFILE.USERNAME_DISPLAY' | translate }}</label>
        <input type="text" disabled class="form-control" id="username" name="username" required [(ngModel)]="catalogueUserData.userName">
      </div>
      <div class="form-group">
        <label for="email">{{ 'PROFILE.EMAIL' | translate }}</label>
        <input type="text" disabled class="form-control" id="email" name="email" required [(ngModel)]="catalogueUserData.userName">
      </div>
      <div class="form-group">
        <label for="defaultLanguage">{{ 'PROFILE.DEFAULT_LANGUAGE' | translate }}</label>
        <select class="form-control" id="defaultLanguage" [(ngModel)]="catalogueUserData.language" (change)="onLanguageChange()">
          <option *ngFor="let language of languages" [ngValue]="language">{{ 'COMMON.LANGS_LONG_' + language.toUpperCase() | translate }}</option>
        </select>
      </div>
    </div>
    <div class="profile-container__right">
      <div class="roles-container">
        <h3 class="">{{ 'PROFILE.ROLES' | translate }}</h3>
        <div class="role-item" *ngFor="let rol of roles">
          <img class="role-item__value-img" width="24" height="24" alt="{{ 'PROFILE.ROL_ICON' | translate }}" [src]="'assets/img/' + rol.icon + '.svg'">
          <div class="role-item__name">{{ 'PROFILE.ROL_' + rol.translation.toUpperCase() | translate }}</div>
          <div class="role-item__value" [ngClass]="{ 'role-item__value--on': rol.enabled }">
            <img class="role-item__value-img" [hidden]="rol.enabled" width="18" height="18" alt="{{ 'PROFILE.NOT_INTERESTED' | translate }}" src="assets/img/not_interested.svg">
            <img class="role-item__value-img" [hidden]="!rol.enabled" width="18" height="18" alt="{{ 'PROFILE.ENABLED' | translate }}" src="assets/img/task_alt.svg">
            <div class="role-item__value-txt">{{ 'COMMON.ENABLED_' + rol.enabled.toString().toUpperCase() | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
